import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Input,
  Tooltip,
  Whisper,
  Stack,
  IconButton,
  InputGroup,
  Form,
  Message,
  Table,
  SelectPicker,
  toaster,
  InputNumber
} from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import useTableHeight from '@/components/useTableHeight';
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import WarningRoundIcon from '@rsuite/icons/WarningRound';
import { ReviewPass } from '@rsuite/icons';
import { Popconfirm } from 'antd';

interface RowDataHSN {
  id: string; // or number, depending on your data
  attributes: {
    hscode: string;
    GstRate: string;
    Description: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const HSNCodeMaster = () => {
  const { Cell } = Table;
  const { tableHeight, tableHeight2 } = useTableHeight();
  const data = ['Continue', 'Discontinue', 'All'].map(item => ({ label: item, value: item }));

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  ////////////////  Function For 6 Start /////////////////

  const [hscode, setHscode] = useState({
    hscode: '',
    Description: '',
    GstRate: '',
    dis: 'Continue'
  });
  // Fetch Data from API Start
  const [hsdata, setHsdata] = useState<RowDataHSN[]>([]);
  const [hnMeta, setHnMeta] = useState<MetaData>();
  const [editedRowIdsHSN, setEditedRowIdsHSN] = useState<string[]>([]);
  const [editedRowIdHSN, setEditedRowIdHSN] = useState<string>();
  const [editedDataHSN, setEditedDataHSN] = useState<
    Record<string, Partial<RowDataHSN['attributes']>>
  >({});
  const [selectedBuyerhsn, setSelectedBuyerhsn] = useState('Continue');
  const [disHSN, setDisHSN] = useState([]);
  const handleBuyerChangehsn = value => {
    setSelectedBuyerhsn(value);
  };
  const [isLoading6, setIsLoading6] = useState(false);
  const [selectedBuyer, setSelectedBuyer] = useState('Continue');
  const [discate, setDiscate] = useState([]);
  const handleBuyerChange = value => {
    setSelectedBuyer(value);
  };
  useEffect(() => {
    fetchData6();
  }, [selectedBuyerhsn]);
  const fetchData6 = async () => {
    if (isLoading6) {
      return;
    }
    setIsLoading6(true);
    let disFilter = '';
    if (selectedBuyer.length > 0) {
      disFilter = `&filters[dis][$eq]=${selectedBuyerhsn}`;
    }
    if (selectedBuyerhsn == 'All') {
      disFilter = '';
    }

    const pageResponse = await fetch(
      `${globalIP}/api/msthscodes?populate=*&pagination[page]=1&sort[0]=id${disFilter}`
    );
    const pageJson = await pageResponse.json();
    const allData = [];
    for (let page = 1; page <= pageJson.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/msthscodes?populate=*&pagination[page]=${page}&sort[0]=id${disFilter}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    const responseformeta = await fetch(
      `${globalIP}/api/msthscodes?populate=*&publicationState=preview`
    );
    const jsonmeta = await responseformeta.json();

    const response2 = await fetch(`${globalIP}/api/msthscodes`);
    const pageJson2 = await response2.json();
    const allData2 = [];
    for (let page = 1; page <= pageJson2.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/msthscodes?populate=*&pagination[page]=${page}`
      );
      const pageJson2 = await pageResponse.json();
      allData2.push(...pageJson2.data);
    }
    setDisHSN(allData2);
    setHnMeta(jsonmeta.meta);
    setHsdata(allData);
    setIsLoading6(false);
  };
  const processInputRef = useRef(null);  // for HSN input field
  const gstRateInputRef = useRef(null);  // for GstRate input field, if you need it
  const descriptionInputRef = useRef(null); // for Description input field
  useEffect(() => {
    console.log('processInputRef:', processInputRef.current);
    if (editedRowIdHSN && processInputRef.current) {
      processInputRef.current.focus();
    }
  }, [editedRowIdHSN]);

  // Depend on editedRowIdHSN to ensure it's set before focusing

  const handleEditRowHSN = rowData => {
    setHscode({ ...rowData.attributes });
    setEditedRowIdHSN(rowData.id);
    setEditedRowIdsHSN(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDataHSN(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));


  };

  const resetHsnCode = () => {
    setHscode({
      hscode: '',
      Description: '',
      GstRate: '',
      dis: 'Continue'
    });
  };
  const handleCancelHsnCode = rowData => {
    resetHsnCode();
    setEditedRowIdHSN('');
    setEditedRowIdsHSN('');
  };

  const url6 = `${globalIP}/api/msthscodes`;
  const submit6 = async e => {
    const trimmedHSN = hscode.hscode?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

    if (trimmedHSN === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.HSN}.
        </Message>,
        { placement: 'topCenter' }
      );
    } else if (specialCharPattern.test(trimmedHSN)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.HSN} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
    } else {
      try {
        const { data: hsnname } = await axios.get(
          `${globalIP}/api/msthscodes?filters[hscode][$eqi]=${trimmedHSN}`
        );
        const existingHscode = disHSN.find(
          item => item.attributes.hscode.toLowerCase() === trimmedHSN.toLowerCase()
        );

        if (hsnname.data.length) {
          toaster.push(
            <Message showIcon type="warning">
              {label[0]?.attributes.HSN} {trimmedHSN} already exists.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          e.preventDefault();
          const formData = new FormData();
          formData.append('data', JSON.stringify({ ...hscode, hscode: trimmedHSN }));

          const response = await fetch(url6, {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            await fetchData6();
            console.log(hscode);

            toaster.push(
              <Message showIcon type="success">
                Data Save Successfully.
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            console.error('Failed to save data');
          }
        }
      } catch (error) {
        console.error(error);
      }

      setHscode({
        hscode: '',
        Description: '',
        GstRate: '',
        dis: 'Continue'
      });
    }
  };

  //  Fetch Data from API End
  const handleInputChange6 = (inputName, value, index) => {
    setHscode({ ...hscode, [inputName]: value });
  };
  const handlehsC = async (catalogId, hs) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...hsdata,
        dis: 'Continue'
      })
    );
    fetch(`${globalIP}/api/msthscodes/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData6();
        toaster.push(
          <Message showIcon type="success">
            {hs} Continue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handlehsD = async (catalogId, hs) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...hsdata,
        dis: 'Discontinue'
      })
    );
    fetch(`${globalIP}/api/msthscodes/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData6();
        toaster.push(
          <Message showIcon type="success">
            {hs} Discontinue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleSaveRowHSN = async (rowId: string) => {
    try {
      // const rowData = hsdata.find(row => row.id === rowId);
      if (!hscode) {
        console.error('Row data not found.');
        return;
      }

      const updatedCategoryName = hscode?.hscode?.trim();
      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

      if (!updatedCategoryName) {
        toaster.push(
          <Message showIcon type="error">
            Please enter {label[0]?.attributes.HSN}.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if validation fails
      }
      // Check for special characters
      if (specialCharPattern.test(updatedCategoryName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.HSN} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if validation fails
      }

      // Check for leading/trailing spaces
      if (updatedCategoryName.startsWith(' ') || updatedCategoryName.endsWith(' ')) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.HSN} cannot start or end with a space.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if validation fails
      }

      // Check for duplicate HSN codes
      const { data: updatehsnname } = await axios.get(
        `${globalIP}/api/msthscodes?filters[hscode][$eqi]=${updatedCategoryName}&filters[id][$ne]=${editedRowIdHSN}`
      );
      if (updatehsnname.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.HSN} {updatedCategoryName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if validation fails
      }
      const response = await fetch(`${globalIP}/api/msthscodes/${editedRowIdHSN}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: { ...hscode, hscode: updatedCategoryName } })
      });

      if (response.ok) {
        // If the API call is successful, update the data
        fetchData6();
        resetHsnCode('');
        setEditedRowIdHSN('');
        setEditedDataHSN(prevData => ({
          ...prevData,
          [editedRowIdHSN]: { ...hscode, hscode: updatedCategoryName } // Ensure UI updates correctly
        }));
        setEditedRowIdsHSN(prevRowIds => [...new Set([...prevRowIds, editedRowIdHSN])]);
      } else {
        // Handle error if needed
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };
  ////////////////  Function For 6 End /////////////////
  ////////////////  Searching For 6 Start /////////////////
  const [searchQuery6, setSearchQuery6] = useState('');
  const [filterStatus6, setFilteredStatus6] = useState('Continue');
  const handleSearch6 = value => {
    setSearchQuery6(value);
  };
  const [HSNFilterData, setHSNFilterData] = useState([]);

  useEffect(() => {
    const HSNFilterData = hsdata
      .slice()
      .reverse()
      .filter(item => {
        const hscode = item.attributes.hscode ? item.attributes.hscode.toLowerCase() : '';
        return hscode.includes(searchQuery6.toLowerCase());
      });
    setHSNFilterData(HSNFilterData);
  }, [hsdata, filterStatus6, searchQuery6]);
  ////////////////  Searching For 6 End /////////////////

  return (
    <>
      <Stack justifyContent="space-between" style={{ marginBottom: '10px' }} className="mstr-panel">
        <Stack spacing={5} className="mstr-panel1">
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>{label[0]?.attributes.HSN}</b>
            </Form.ControlLabel>
            <InputNumber
              step={null}
              id="hscode"
              name="hscode"
              autoComplete="off"
              ref={processInputRef}  // This will focus the input when required
              value={hscode && hscode.hscode ? hscode.hscode : ''}
              onChange={value => handleInputChange6('hscode', value, 0)}
            />
          </Stack>

          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>Gst Rate</b>
            </Form.ControlLabel>
            <InputNumber
              step={null}
              id="GstRate"
              autoComplete="off"
              ref={processInputRef}
              name="GstRate"
              // style={{ width: '40%' }}
              value={hscode && hscode.GstRate ? hscode.GstRate : ''}
              onChange={value => handleInputChange6('GstRate', value, 0)}
            />
          </Stack>
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>Description</b>
            </Form.ControlLabel>
            <Input
              id="Description"
              name="Description"
              // style={{ width: '180%' }}
              value={hscode && hscode.Description ? hscode.Description : ''}
              onChange={value => handleInputChange6('Description', value, 0)}
              onPressEnter={submit6}
            />
          </Stack>
          {editedRowIdHSN ? (
            <Button
              appearance="primary"
              color="cyan"
              onClick={handleSaveRowHSN}
              className="mstr-btn"
              style={{ marginTop: '16px', marginRight: '5px' }}
            >
              {' '}
              Update
            </Button>
          ) : (
            <Button
              appearance="primary"
              color="cyan"
              onClick={submit6}
              className="mstr-btn"
              style={{ marginTop: '16px', marginRight: '5px' }}
            >
              {' '}
              Add
            </Button>
          )}
        </Stack>
        <Stack className="mstr-search" spacing={5} style={{ marginTop: '16px' }}>
          <SelectPicker
            data={data}
            placeholder="Status"
            labelKey="label"
            value={selectedBuyerhsn}
            onChange={handleBuyerChangehsn}
            searchable={false}
            valueKey="value"
            size="md"
            appearance="default"
            style={{ width: 130 }}
            cleanable={false}
          />
          <InputGroup inside>
            <Input placeholder="Search" type="text" value={searchQuery6} onChange={handleSearch6} />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
        </Stack>
      </Stack>
      <Table
        rowHeight={60}
        data={HSNFilterData}
        height={tableHeight}
        rowKey="id"
        bordered
        cellBordered
        loading={isLoading6}
      >
        <Table.Column width={60} fixed>
          <Table.HeaderCell>
            <b>Sr No.</b>
          </Table.HeaderCell>
          <Cell>{(_, rowIndex) => +rowIndex + 1}</Cell>
        </Table.Column>
        <Table.Column width={130}>
          <Table.HeaderCell>
            <b>{label[0]?.attributes.HSN}</b>
          </Table.HeaderCell>
          <Table.Cell>
            {
              rowData =>
                rowData.attributes.hscode
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={130}>
          <Table.HeaderCell>
            <b>GstRate</b>
          </Table.HeaderCell>
          <Table.Cell>
            {
              rowData =>
                rowData.attributes.GstRate
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={130} flexGrow={1}>
          <Table.HeaderCell>
            <b>Description</b>
          </Table.HeaderCell>
          <Table.Cell>
            {
              rowData =>
                rowData.attributes.Description
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={100} fixed="right">
          <Table.HeaderCell>
            <b>Action</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              editedRowIdsHSN.includes(rowData.id) ? (
                <div>
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowHSN(rowData)}
                    style={{ marginRight: '10px' }}
                  />
                  <IconButton size="sm" icon={<CloseIcon />} active onClick={handleCancelHsnCode} />
                </div>
              ) : (
                <div>
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowHSN(rowData)}
                  />
                  {rowData.attributes.dis === 'Discontinue' ? (
                    <Popconfirm
                      title="Continue HSN CODE"
                      description="Are you sure you want to continue this HSN CODE?"
                      onConfirm={() => handlehsC(rowData.id, rowData.attributes.hscode)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Continue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<CheckRoundIcon />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handlehsC(rowData.id, rowData.attributes.hscode)}
                        />
                      </Whisper>
                    </Popconfirm>
                  ) : (
                    <Popconfirm
                      title="Discontinue HSN CODE"
                      description="Are you sure you want to discontinue this HSN CODE?"
                      onConfirm={() => handlehsD(rowData.id, rowData.attributes.hscode)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Discontinue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<ReviewPass />}
                          active
                          style={{ marginLeft: '10px' }}
                        // onClick={() => handlehsD(rowData.id, rowData.attributes.hscode)}
                        />
                      </Whisper>
                    </Popconfirm>
                  )}
                </div>
              )
            }
          </Table.Cell>
        </Table.Column>
      </Table>
      <div>
        <p>
          <small>Total row:{HSNFilterData.length}</small>
        </p>
      </div>
    </>
  );
};

export default HSNCodeMaster;
